import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "held.token";

axios.interceptors.request.use((config) => {
  const t = localStorage.getItem(KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem(KEY);
    if (!t) { setLoading(false); return; }
    axios.get(`${API}/auth/me`)
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem(KEY))
      .finally(() => setLoading(false));
  }, []);

  const signup = async (payload) => {
    const { data } = await axios.post(`${API}/auth/signup`, payload);
    localStorage.setItem(KEY, data.token);
    setUser(data.user);
    return data.user;
  };
  const login = async (payload) => {
    const { data } = await axios.post(`${API}/auth/login`, payload);
    localStorage.setItem(KEY, data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem(KEY);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signup, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
